import { DataFetchingClient } from 'data-fetching-client';
export const dataFetchingClient = new DataFetchingClient();